<template>
    <EditingDialog
        :context="context"
        :showSnackbar="true"
        snackbarTextLangConst="lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON"
        :useDifferentShowDialogProp="true"
        maxDialogWidth="1200"
        maxCardHeight="800"
    >
        <template v-slot:editForm>
            <v-row>
                <v-col>
                    <BaseEditPageDropdown
                        field="SourceAlvId"
                        :label="$t('lang_GENERIC_CAPTION_SOURCE')"
                        :items="sourceOptions"
                        :context="context"
                        rules="required"
                        :alvqa="alvqa + '-dropdown-source'"
                    />
                </v-col>
                <v-col>
                    <BaseEditPageDropdown
                        field="SubcatalogId"
                        :label="$t('lang_GENERIC_CAPTION_CATALOGUE')"
                        :items="catalogueOptions"
                        :context="context"
                        :clearable="false"
                        rules="alvDropdownRequired"
                        :alvqa="alvqa + '-dropdown-catalogue'"
                    />
                </v-col>
                <v-col>
                    <BaseEditPageTextField
                        :context="context"
                        field="AgreementNumber"
                        :label="$t('lang_CONTRACTS_PUBLISHING_CAPTION_AGREEMENT_NUMBER')"
                        :withMargin="false"
                        rules="required"
                        maxlength="14"
                        :alvqa="alvqa + '-textfield-agreement-number'"
                    />
                </v-col>
            </v-row>
        </template>
    </EditingDialog>
</template>

<script>
import EditingDialog from '@/components/_dialogs/EditingDialog'
import BaseEditPageTextField from '@/components/_editForm/BaseEditPageTextField'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'

export default {
    name: "PublishingContractsAgreementNumbersEditPanelDialog",
    components: {
        EditingDialog,
        BaseEditPageTextField,
        BaseEditPageDropdown
    },
    data() {
        return {
            context: "PublishingContractsAgreementNumbers",
            alvqa: "contracts-publishing-edit-form-panel-agreement-numbers-editing-dialog"
        }
    },
    computed: {
        // rows of other entries, i.e. everything that already blocks a catalogue/society pair
        otherRows() {
            const editedRowId = this.$store.getters.getSelectedPublishingContractsAgreementNumbers
            return (this.$store.getters.getPublishingContractsAgreementNumbers || [])
                .filter(row => row.id !== editedRowId)
        },
        selectedCatalogue() { return this.$store.getters.getPublishingContractsAgreementNumbersDetailsSubcatalogId },
        selectedSource() { return this.$store.getters.getPublishingContractsAgreementNumbersDetailsSourceAlvId },
        // only one number per catalogue and society, so catalogues that already have a number for
        // the chosen society are not offered again
        catalogueOptions() {
            const subCatalogueCaption = this.$t('lang_PUBLISHING_WORKS_CAPTION_SUBCATALOGUE')
            const mainName = this.getLicensorName(this.$store.getters.getPublishingContractsDetailsLicensor)
            const mainCaption = this.$t('lang_CONTRACTS_PUBLISHING_CAPTION_MAIN_CATALOGUE')

            const options = [{ text: mainName ? mainCaption + ': ' + mainName : mainCaption, value: null }]
            const subCatalogues = this.$store.getters.getPublishingContractsSubCatalogues || []
            subCatalogues.forEach(subCatalogue => {
                options.push({
                    text: subCatalogueCaption + ': ' + this.getLicensorName(subCatalogue.licensor),
                    value: subCatalogue.id
                })
            })

            if (!this.selectedSource) return options

            const takenCatalogues = this.otherRows
                .filter(row => row.sourceAlvId === this.selectedSource)
                .map(row => row.subcatalogId || null)

            return options.filter(option =>
                option.value === this.selectedCatalogue || takenCatalogues.indexOf(option.value) === -1
            )
        },
        // counterpart of catalogueOptions: societies already used in the chosen catalogue are gone
        sourceOptions() {
            // only societies the account is a direct member of, same list as the CWR export recipient
            let options = (this.$store.getters.getAzSocietiesWhereDirectMember || [])
                .map(society => ({ value: society.alvId, text: society.societyAcronym }))

            if (this.selectedCatalogue !== '' && this.selectedCatalogue !== undefined) {
                const takenSources = this.otherRows
                    .filter(row => (row.subcatalogId || null) === this.selectedCatalogue)
                    .map(row => row.sourceAlvId)

                options = options.filter(source =>
                    source.value === this.selectedSource || takenSources.indexOf(source.value) === -1
                )
            }

            // membership id of that society was removed in A-Z afterwards: keep the saved value
            // visible so the field is not blank, but do not offer it for selection
            if (this.selectedSource && !options.some(option => option.value === this.selectedSource)) {
                options = options.concat({
                    value: this.selectedSource,
                    text: this.$t('lang_GENERIC_CAPTION_NOT_A_MEMBER') + ' (' + this.selectedSource + ')',
                    disabled: true
                })
            }

            return options
        },
    },
    methods: {
        getLicensorName(licensor) {
            if (!licensor) return ''
            if (licensor.group !== null && licensor.group !== undefined && licensor.group !== '') return licensor.group
            return licensor.gemaName || licensor.name || ''
        },
    },
}
</script>
